"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../../config/types");
const offchainAccountCollateral_1 = __importDefault(require("./offchainAccountCollateral"));
const offchainAccountBorrowable_1 = __importDefault(require("./offchainAccountBorrowable"));
class OffchainAccountLendingPool {
    constructor(account, lendingPool) {
        this.getAccount = () => this.account;
        this.getLendingPool = () => this.lendingPool;
        // Shortcuts
        this.getBorrowableA = () => this.poolTokens[types_1.PoolTokenType.BorrowableA];
        this.getBorrowableB = () => this.poolTokens[types_1.PoolTokenType.BorrowableB];
        this.getCollateral = () => this.poolTokens[types_1.PoolTokenType.Collateral];
        this.account = account;
        this.lendingPool = lendingPool;
        this.poolTokens = {
            [types_1.PoolTokenType.Collateral]: new offchainAccountCollateral_1.default(this),
            [types_1.PoolTokenType.BorrowableA]: new offchainAccountBorrowable_1.default(this, types_1.PoolTokenType.BorrowableA),
            [types_1.PoolTokenType.BorrowableB]: new offchainAccountBorrowable_1.default(this, types_1.PoolTokenType.BorrowableB),
        };
    }
    getPoolToken(poolTokenType) {
        return this.poolTokens[poolTokenType];
    }
    getLendingPoolPosition() {
        return __awaiter(this, void 0, void 0, function* () {
            const userData = yield this.account.getUserData();
            if (!userData)
                return undefined;
            const userDataOfFactory = userData[this.lendingPool.getFactory()];
            const pairAddress = this.lendingPool.getPairAddress();
            const supplyPositions = userDataOfFactory.supplyPositions[pairAddress];
            const borrowPositions = userDataOfFactory.borrowPositions[pairAddress];
            return {
                collateralPosition: userDataOfFactory.collateralPositions[pairAddress],
                supplyPositions: {
                    [types_1.PoolTokenType.BorrowableA]: supplyPositions ? supplyPositions[types_1.PoolTokenType.BorrowableA] : undefined,
                    [types_1.PoolTokenType.BorrowableB]: supplyPositions ? supplyPositions[types_1.PoolTokenType.BorrowableB] : undefined,
                },
                borrowPositions: {
                    [types_1.PoolTokenType.BorrowableA]: borrowPositions ? borrowPositions[types_1.PoolTokenType.BorrowableA] : undefined,
                    [types_1.PoolTokenType.BorrowableB]: borrowPositions ? borrowPositions[types_1.PoolTokenType.BorrowableB] : undefined,
                },
            };
        });
    }
    getBorrowerEquityValue() {
        return __awaiter(this, void 0, void 0, function* () {
            const collateralValue = yield this.getCollateral().getValue();
            const borrowedValueA = yield this.getBorrowableA().getBorrowedValue();
            const borrowedValueB = yield this.getBorrowableB().getBorrowedValue();
            return collateralValue - borrowedValueA - borrowedValueB;
        });
    }
}
exports.default = OffchainAccountLendingPool;
